import { YM_DATE_FORMAT } from "@/constants";
import { FilterType } from "@/lib/filters";
import type { FilterValue } from "@/types/dataTableSettings";
import { DateTime } from "luxon";

/** Parses table filter value (YYYY-MM) into the first day of that month, or undefined. */
export const monthYearFilterToDate = (
  filter?: FilterValue,
): Date | undefined => {
  if (
    filter?.filter !== FilterType.EqualsString ||
    typeof filter.value !== "string"
  )
    return;
  const dt = DateTime.fromFormat(filter.value, YM_DATE_FORMAT);
  return dt.isValid ? dt.startOf("month").toJSDate() : undefined;
};
